import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Routes, useLocation } from 'react-router'
import { ThemeProvider } from 'styled-components'

import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'
import CashierDesk from './features/CashierDesk'
import CustomerDisplay from './features/CustomerDisplay/CustomerDisplay'
import Diagnostics from './features/Diagnostics/Diagnostics'
import { I18nProvider } from './lib/I18nProvider'
import { useTheme } from './lib/hooks'
import Style from './style'

// Global error/crash catcher
window.addEventListener('error', (event) => {
  console.error('[APP] Uncaught error:', event.message, 'at', event.filename, ':', event.lineno)
})
window.addEventListener('unhandledrejection', (event) => {
  console.error('[APP] Unhandled promise rejection:', event.reason)
})

console.log('[APP] Script loaded at', new Date().toISOString())
console.log('[APP] URL:', window.location.href)

const App = () => {
  const { t, i18n } = useTranslation()
  const themes = useTheme()
  const location = useLocation()

  useEffect(() => {
    document.title = themes.title ? `${themes.title} - ${t('appTitle')}` : t('appTitle')
  }, [themes, t, i18n.language])

  useEffect(() => {
    console.log('[APP] Route:', location.pathname, location.search)
    console.log('[APP] Theme loaded:', themes.title, '| Products:', themes.products?.length || 0)
    console.log('[APP] Viewport:', window.innerWidth, 'x', window.innerHeight, '| DPR:', window.devicePixelRatio)
  }, [location, themes])

  return (
    <ThemeProvider theme={themes}>
      <I18nProvider>
        <Style />
        <ErrorBoundary name="App">
          <Routes>
            <Route path="/" element={<CashierDesk />} />
            <Route path="/customer" element={<CustomerDisplay />} />
            <Route path="/diagnostics" element={<Diagnostics />} />
          </Routes>
        </ErrorBoundary>
      </I18nProvider>
    </ThemeProvider>
  )
}

export default App
